<template>
  <date-picker ref="datepicker" class="inline-block h-full" v-model="date" :attributes="attrs"
               :min-date="minDate"
               :max-date="maxDate" :select-attribute="selectedAttr" trim-weeks
               @dayclick="onDayClick"
               :locale="userLocale">
    <template v-slot="{ togglePopover }">
      <v-btn :color="buttonColor" @click="togglePopover({ placement: 'auto-start' })">
        <span class="primary--text d-inline-block">{{ buttonName }}</span>
      </v-btn>
    </template>
  </date-picker>
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';

@Component
@Components({ DatePicker })
@MapGetters(['userLocale'])
export default class PeriodPicker extends Vue {
  @Prop({
    Array,
    required: true,
    default: null,
    validator(periods) {
      return periods && Array.isArray(periods);
    }
  }) periods;

  @Prop({
    Object,
    required: true,
    default: null,
  }) selectedPeriod;

  date = null;

  selectedAttr = {
    highlight: {}
  }

  get buttonColor() {
    return this.selectedPeriod?.isPreviousPeriod ? '#FFFDE7' : 'secondary';
  }

  get attrs() {
    return [
      {
        highlight: {
          fillMode: 'outline',
          color: 'yellow',
        },
        dates: new Date(),
        order: 99
      },
      {
        highlight: {
          start: {
            fillMode: 'solid',
            color: 'var(--v-primary-base)',
            contentStyle: {
              fontWeight: 'var(--font-bold)'
            },
            style: {
              backgroundColor: 'var(--v-primary-base)',
              opacity: 1
            }
          },
          base: {
            fillMode: 'solid',
            color: 'var(--v-primary-base)',
            contentStyle: {
              fontWeight: 'var(--font-bold)'
            },
            style: {
              backgroundColor: 'var(--v-primary-base)',
              opacity: 1
            }
          },
          end: {
            fillMode: 'solid',
            color: 'var(--v-primary-base)',
            contentStyle: {
              fontWeight: 'var(--font-bold)'
            },
            style: {
              backgroundColor: 'var(--v-primary-base)',
              opacity: 1
            }
          },
        },
        dates: { start: this.selectedPeriod?.startDate, end: this.selectedPeriod?.endDate },
      },
      ...this.periods.map((period) => (period.guid !== this.selectedPeriod.guid ? {
        highlight: {
          start: {
            fillMode: 'solid',
            color: 'lightgray',
            contentStyle: {
              fontWeight: 'var(--font-bold)'
            },
            style: {
              backgroundColor: 'lightgray',
              opacity: 1
            }
          },
          base: {
            fillMode: 'solid',
            color: 'lightgray',
            contentStyle: {
              fontWeight: 'var(--font-bold)'
            },
            style: {
              backgroundColor: 'lightgray',
              opacity: 1
            }
          },
          end: {
            fillMode: 'solid',
            color: 'lightgray',
            contentStyle: {
              fontWeight: 'var(--font-bold)'
            },
            style: {
              backgroundColor: 'lightgray',
              opacity: 1
            }
          },
        },
        dates: { start: period.startDate, end: period.endDate }
      } : undefined)).filter((obj) => obj !== undefined)
    ];
  }

  get flatDatesList() {
    return this.periods?.flatMap((period) => [period.startDate, period.endDate]);
  }

  get minDate() {
    return this.flatDatesList?.reduce((prev, curr) => (prev && prev < curr ? prev : curr), null);
  }

  get maxDate() {
    return this.flatDatesList?.reduce((prev, curr) => (prev && prev > curr ? prev : curr), null);
  }

  get buttonName() {
    return this.selectedPeriod?.name;
  }

  findPeriodFromDate(date) {
    return this.periods.find((period) => period.startDate <= date && date <= period.endDate);
  }

  onDayClick({ id: selectedDateStr }) { // Returns a string with format YYYY-MM-DD
    // eslint-disable-next-line no-underscore-dangle
    this.$refs.datepicker.$data.value_ = new Date(); // Reset date
    const selectedPeriod = this.findPeriodFromDate(new Date(selectedDateStr));

    if (selectedPeriod !== undefined) {
      this.$emit('period-selected', selectedPeriod);
    }
  }
}
</script>
